export const PACKAGE_VERSION = '0.26.0';
//# sourceMappingURL=package-version.js.map